<template>
  <v-card>
    <v-card-text class="text-xs-center">
      <figure>
        <UploadIcon/>
      </figure>Select Files from Google Drive
      <p>
        <span>Authenticate with Google Drive</span>
      </p>
      <p v-if="isLoading">Authenticating ...</p>
      <v-btn :loading="isLoading" color="primary" @click="driveIconClicked();">Connect to Google Drive</v-btn>
    </v-card-text>
    <AttachmentList :tempAttachments="getTempAttachments"/>
  </v-card>
</template>

<script>
import AttachmentList from "./AttachmentList";
import UploadIcon from "./UploadIcon";
import { mapGetters } from 'vuex';

export default {
  name: "Attachment",
  props: ["film_id"],
  data() {
    return {
      tempAttachments: [],
      attachments: [],
      pickerApiLoaded: false,
      developerKey: this.DEFINES.gdDevKey,
      clientId: this.DEFINES.gdClientId,
      scope: "https://www.googleapis.com/auth/drive.readonly",
      oauthToken: null,
      refreshCode: null,
      isLoading: false
    };
  },
  components: {
    AttachmentList: AttachmentList,
    UploadIcon
  },
  computed: {
    getTempAttachments() {
      return this.tempAttachments;
    },
     ...mapGetters('auth', {
      isUploadModeLogin : 'isUploadModeLogin',
    }),
  },

  mounted() {
    this._loadGoogleApi();
  },

  methods: {
    _loadGoogleApi(){
      let gDrive = document.createElement("script");
      gDrive.setAttribute("type", "text/javascript");
      gDrive.setAttribute("src", "https://apis.google.com/js/api.js");
      document.head.appendChild(gDrive);
    },

    // function called on click of drive icon
    async driveIconClicked() {
      var _this = this;
      this.isLoading = true;

      if(!this.isUploadModeLogin){
        var result = await this.$store.dispatch("company/getGapiToken");
        this.oauthToken = result.token;

        if(this.oauthToken){
            gapi.load("picker", () => {
              this.pickerApiLoaded = true;
              this.createPicker();
            });
            return;
        }
      }

      // load auth and init to authorize
      await gapi.load("auth2", () => {
        gapi.auth2.init(
          {
            client_id: this.clientId,
            scope: this.scope,
            immediate: false,
          }).then(function(){
            //1. after init load current user
            var ga = gapi.auth2.getAuthInstance();
            var currentUser = ga.currentUser.get();

            //2. isSignedIn
            if(currentUser.isSignedIn() && _this.oauthToken != null){
              //3. then set oauth token and create picker
              // OR
              _this.oauthToken = currentUser.getAuthResponse().access_token;
              gapi.load("picker", () => {
                _this.pickerApiLoaded = true;
                _this.createPicker();
              });
              return;
            }

            //4. if not signIn then grant offline access
            ga.grantOfflineAccess({'redirect_uri' : 'postmessage', 'approval_prompt' : 'force'})
            .then(function(res){
              //5. after getting code
              _this.handleAuthResult(res.code);
            });
          });
      });
    },

    async handleAuthResult(code) {
      this.refreshCode = code;
       //6. sent code to api
      // at api, complete token with refresh token will be generated

      // if uploadModeLogin then setToken to user api
      try {
          if(this.isUploadModeLogin){
            var result = await this.$store.dispatch("user/setGapiToken", {
              'code' : code
            });
          }else{
            var result = await this.$store.dispatch("company/setGapiToken", {
              'code' : code
            });
          }
          this.oauthToken = result.token;
          //7. load picker
          gapi.load("picker", () => {
            this.pickerApiLoaded = true;
            this.createPicker();
          });

      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }


    },

    // Create and render a Picker object for picking user Photos.
    createPicker() {
      this.isLoading = false;
      if (this.pickerApiLoaded && this.oauthToken) {
        // show only videos
        var picker = new google.picker.PickerBuilder()
          .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
          .addView(google.picker.ViewId.DOCS_VIDEOS)
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey(this.developerKey)
          .setCallback(this.pickerCallback)
          .build();
        picker.setVisible(true);
      }
    },
    async pickerCallback(data) {
      // console.log("PickerCallback Files : ", data);
      var url = "nothing";
      var name = "nothing";
      if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
        var doc = data[google.picker.Response.DOCUMENTS][0];
        // sent api request to download the file at server side
        // set into list to display the file
        this.sentToUpload(doc);
        url = doc[google.picker.Document.URL];
        name = doc.name;

        let docs = data.docs;
        var param = { fileId: doc.id, oAuthToken: this.oauthToken, name: name };
        let attachments = [];
        for (let i = 0; i < docs.length; i++) {
          let attachment = {};
          attachment._id = docs[i].id;
          attachment.title = docs[i].name;
          attachment.name = docs[i].name + "." + docs[i].mimeType.split("/")[1];
          attachment.type = "gDrive";
          attachment.description = "Shared with GDrive";
          attachment.extension =
            "." +
            docs[i].mimeType.substring(docs[i].mimeType.lastIndexOf(".") + 1);
          attachment.iconURL = docs[i].iconUrl;
          attachment.size = docs[i].sizeBytes;
          attachment.user = JSON.parse(localStorage.getItem("user"));
          attachment.thumb = null;
          attachment.thumb_list = null;
          attachments.push(attachment);
        }
        this.tempAttachments = [...attachments];
      }
      this.pickerApiLoaded = false;
    },

    async sentToUpload(file){
      try {
        await this.$store.dispatch("film/gDriveUpload", {
          film_id : this.film_id,
          fileId : file.id,
          fileName: file.name,
          fileSize: file.sizeBytes,
          fileMimeType: file.mimeType,
          code: this.refreshCode
        });
        this.$store.dispatch('app/showMessage', {
            message: this.$t('rms.upload.success'),
            color: 'success',
        });
        this.$emit('complete');
      } catch (error) {
         this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    }
  },

};
</script>
